var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#D7E2F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9667_54947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33301C8.32001 5.33301 5.33334 8.31967 5.33334 11.9997C5.33334 15.6797 8.32001 18.6663 12 18.6663C15.68 18.6663 18.6667 15.6797 18.6667 11.9997C18.6667 8.31967 15.68 5.33301 12 5.33301ZM6.66668 11.9997C6.66668 11.593 6.72001 11.193 6.80668 10.813L9.99334 13.9997V14.6663C9.99334 15.3997 10.5933 15.9997 11.3267 15.9997V17.2863C8.70668 16.953 6.66668 14.713 6.66668 11.9997ZM15.9267 15.5997C15.7533 15.0597 15.26 14.6663 14.66 14.6663H13.9933V12.6663C13.9933 12.2997 13.6933 11.9997 13.3267 11.9997H9.32668V10.6663H10.66C11.0267 10.6663 11.3267 10.3663 11.3267 9.99967V8.66634H12.66C13.3933 8.66634 13.9933 8.06634 13.9933 7.33301V7.05967C15.9467 7.84634 17.3333 9.76634 17.3333 11.9997C17.3333 13.3863 16.7933 14.653 15.9267 15.5997Z",
    fill: "#3E4C5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9667_54947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/GlobeIcon.9d3d43b90aeb813c39c07373417f7c01.svg";
export { ForwardRef as ReactComponent };